var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBibliotecaAlunoNaoSelecionado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 28V13C12.5 12.337 12.7634 11.7011 13.2322 11.2322C13.7011 10.7634 14.337 10.5 15 10.5H27.5C27.7652 10.5 28.0196 10.6054 28.2071 10.7929C28.3946 10.9804 28.5 11.2348 28.5 11.5V29.5C28.5 29.7652 28.3946 30.0196 28.2071 30.2071C28.0196 30.3946 27.7652 30.5 27.5 30.5H15C14.337 30.5 13.7011 30.2366 13.2322 29.7678C12.7634 29.2989 12.5 28.663 12.5 28ZM12.5 28C12.5 27.337 12.7634 26.7011 13.2322 26.2322C13.7011 25.7634 14.337 25.5 15 25.5H28.5",
    stroke: "#8E58BF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBibliotecaAlunoNaoSelecionado);
export default __webpack_public_path__ + "static/media/iconBibliotecaAlunoNaoSelecionado.764b1435f7eb4c51b2ba37e1a2f3d09a.svg";
export { ForwardRef as ReactComponent };